import Breadcrumbs from "../atoms/Breadcrumbs";
import NewsFilters from "../organisms/NewsFilters";
import CardDefault from "../molecules/CardDefault";
import Grid from "../atoms/Grid";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Pagination from "../atoms/Pagination";
import CardMedia from "../molecules/CardMedia";

export default function NewsTemplate({
  results,
  info,
  categories,
  categoryObject,
  currentPage,
  pageSize,
  translations,
  locale,
  defaultLocale
}) {

  const router = useRouter();
  const [selectedFilter, setSelectedFilter] = useState("all-posts");

  useEffect(() => {
    if (router.query.category) {
      setSelectedFilter(router.query.category);
    } else {
      setSelectedFilter("all-posts");
    }
  }, [router.query]);

  const handlePageChange = (newPage) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, page: newPage },
    });
  };

  const breadcrumbs = [
    {
      name: translations['home'],
      href: "/",
    },
    {
      name: info.attributes.title,
      href: "/news",
    },
  ];

  return (
    <div>
      <div className="relative bg-gray-200 container-custom pt-120 pb-20 1024:pt-190 1024:pb-40">
        <Breadcrumbs breadcrumbs={breadcrumbs} locale={locale} defaultLocale={defaultLocale} />
        <div className="flex flex-col">
          {categoryObject.length > 0 && (
            <span className="text-m font-medium leading-125 tracking-05">
              {info.attributes.title}
            </span>
          )}
          {categoryObject.length > 0 ? (
            <h1 className="text-xl 640:text-xxl 1024:text-xxxl font-medium">
              {categoryObject[0].attributes.title}
            </h1>
          ) : (
            <h1 className="text-xl 640:text-xxl 1024:text-xxxl font-medium">
              {info.attributes.title}
            </h1>
          )}
        </div>
      </div>
      <NewsFilters
        translations={translations}
        categories={categories}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
      />
      <div className="container-custom py-40">
        <Grid extraClass="gap-y-20 640:!gap-y-40">
          {results.data.length ? (
            results.data.map((result, index) =>
              result.attributes.news_category.data.attributes.in_the_media ? (
                <div key={index} className="col-span-4 640:col-span-6">
                  <CardMedia
                    translations={translations}
                    title={result?.attributes?.title}
                    image={result?.attributes?.image?.data?.attributes?.url}
                    date={result?.attributes?.date}
                    link={result?.attributes?.external_link ? result?.attributes?.external_link: `news/${result?.attributes?.slug}`}
                    media_type={result?.attributes?.media_type}
                    type="external"
                  />
                </div>
              ) : (
                <div
                  className="col-span-4 640:col-span-3 1024:col-span-4"
                  key={index}
                >
                  <CardDefault
                    translations={translations}
                    title={result?.attributes?.title}
                    image={result?.attributes?.image?.data?.attributes?.url}
                    date={result?.attributes?.date}
                    category={
                      result?.attributes?.news_category?.data.attributes?.title
                    }
                    link={`news/${result?.attributes?.slug}`}
                    type="internal"
                    isInNews
                  />
                </div>
              )
            )
          ) : (
            <span className="col-span-12 text-xxs font-medium leading-115 tracking-05">
              {translations['news_no_results']}
            </span>
          )}
        </Grid>
      </div>
      {results.meta.pagination.pageCount > 1 && (
        <Pagination
          currentPage={currentPage}
          pageCount={results.meta.pagination.pageCount}
          pageSize={pageSize}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
}
